/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NavigationContext } from 'gatsby-core-theme/src/components/organisms/navigation/navigationContext';
import { FaList } from '@react-icons/all-files/fa/FaList';
import styles from './menu-icon.module.scss';

const MenuIcon = ({ onClick }) => {
  const { showMenu } = useContext(NavigationContext);

  return (
    <button
      className={`${styles.menuIcon} ${showMenu && styles.active} btn-cta`}
      onKeyDown={() => onClick()}
      onClick={() => onClick()}
      type="button"
      aria-label="Menu Icon"
      tabIndex={0}
    >
      <FaList />
    </button>
  );
};

MenuIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default MenuIcon;
